import { render, staticRenderFns } from "./hqglZcJIaofuregMainDetail.vue?vue&type=template&id=30cdcd70&scoped=true&"
import script from "./hqglZcJIaofuregMainDetail.vue?vue&type=script&lang=js&"
export * from "./hqglZcJIaofuregMainDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglZcJIaofuregMainDetail.vue?vue&type=style&index=0&id=30cdcd70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdcd70",
  null
  
)

export default component.exports